import projects from './project';
import webmaster from './webmaster';
import monitoring from './monitoring';
import googleSearch from './googleSearch.json';

export default {
  ...projects,
  ...webmaster,
  ...monitoring,
  ...googleSearch,
};
